module.exports = __webpack_public_path__ + "fonts/nunito-sans-v6-latin-200.3f69f8c7.woff2";